module.exports = __webpack_public_path__ + "img/71400.350ceec8.jpg";